export default "__VITE_ASSET__D7Lf7dOi__"